import { render, staticRenderFns } from "./security_training_promo.vue?vue&type=template&id=3d1af2cf&"
import script from "./security_training_promo.vue?vue&type=script&lang=js&"
export * from "./security_training_promo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports